// One FetchError, re-exported.
//
// This file used to declare a second class with the same name and the same
// body as the one in src/exceptions/exceptions.ts, and roughly half the
// network layer imported each. They are distinct constructors, so
// `err instanceof FetchError` was false whenever the error came from the other
// half, and a later branch made it
// matter by having apiUpdateInquiry ("../exceptions") throw for the first time
// while Requisitions.ts catches with the other one.
//
// Re-exported rather than deleted so the ~10 modules importing "util/exceptions"
// keep working; both paths now name the same class.
export { FetchError } from "exceptions/exceptions";
